import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AddNew24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 3C12.5254 3 12.9513 3.42593 12.9513 3.95134V11.0487H20.0487C20.5741 11.0487 21 11.4746 21 12C21 12.5254 20.5741 12.9513 20.0487 12.9513H12.9513V20.0487C12.9513 20.5741 12.5254 21 12 21C11.4746 21 11.0487 20.5741 11.0487 20.0487V12.9513H3.95134C3.42593 12.9513 3 12.5254 3 12C3 11.4746 3.42593 11.0487 3.95134 11.0487H11.0487V3.95134C11.0487 3.42593 11.4746 3 12 3Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
